

export const DRUG_CLASSES = [
    '5-Alpha Reductase Inhibitor (5-ARI)', 
    'Proton Pump Inhibitor (PPI)', 
    'Fluoroquinolone'
]
